import { getProConsole } from '@tencent/v-common-utils';
import getAegis from '@/utils/aegis';

const aegis = getAegis();

export enum FrontOperationType {
  ExecuteCallback = 'execute-callback',
}

// interface FrontOperationData {
//   type: FrontOperationType;
//   payload: FrontOperationPayload;
// }

// type FrontOperationPayload = ExecuteCallbackPayload;

interface ExecuteCallbackPayload {
  callbackId: number;
  data: any;
}

const FRONT_BRIDGE_WINDOW_KEY = 'VJSBridgeFront';

export class VJSBridgeFront {
  static callbackIdCounter = 1;
  static callbacks: { [id: string]: (data?: any) => void } = {};
  static getInstance() {
    if ((window as any)[FRONT_BRIDGE_WINDOW_KEY]) {
      getProConsole()?.info('Bridge Front has been generated already');
      return (window as any)[FRONT_BRIDGE_WINDOW_KEY];
    }
    this.setup();
  }
  static setup() {
    (window as any)[FRONT_BRIDGE_WINDOW_KEY] = VJSBridgeFront;
    getProConsole()?.success('Bridge Front setup');
  }
  static registerCallback(callback: (data?: any) => void) {
    const callbackId = this.callbackIdCounter;
    this.callbacks[callbackId] = callback;
    this.callbackIdCounter += 1;
    return callbackId;
  }
  static removeCallback(callbackId: number) {
    Reflect.deleteProperty(this.callbacks, callbackId);
  }
  static getCallback(callbackId: number) {
    return this.callbacks[callbackId] || (() => {});
  }
  static getCallbackId() {
    return this.callbackIdCounter;
  }
  static postMessage(operationData: string) {
    try {
      const { type, payload } = JSON.parse(operationData.replace(/\r\n|\n/g, '\\n'));
      switch (type) {
        case FrontOperationType.ExecuteCallback:
          this.handleExecuteCallback(payload);
          break;
        default:
          console.error(`Error occurs. There's no such type "${type}"`);
      }
    } catch (error) {
      aegis?.report({
        msg: '解析bridge payload错误',
        ext1: 'parse payload failed',
        ext2: operationData,
      });
      console.error(
        'Parse payload failed. Original Data: ',
        operationData,
        '\n Type is: ',
        typeof operationData,
      );
    }
  }

  /**
   * 处理执行回调操作
   *
   * @private
   * @param {ExecuteCallbackPayload} payload 回调的类型
   * @memberof VJSBridgeFront
   */
  static handleExecuteCallback(payload: ExecuteCallbackPayload) {
    const { callbackId, data } = payload;
    if (!callbackId) {
      console.error('Error occurs. CallbackId is invalid. Original payload', payload);
      return;
    }
    const callback = VJSBridgeFront.getCallback(callbackId);
    if (!callback) {
      console.error(`Callback "${callbackId}" not exist.`);
      return;
    }
    console.log('Callback Data: ', data);
    callback?.(data);
    this.removeCallback(callbackId);
  }
}
